import React, { useState, useEffect } from 'react'
import { LuClock } from 'react-icons/lu'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { HiOutlineXCircle } from 'react-icons/hi2'
import { FaRegTrashCan } from 'react-icons/fa6'
import { BiBuildings } from 'react-icons/bi'
import { HiOutlineIdentification } from 'react-icons/hi2'
import { MdOutlineNotes } from 'react-icons/md'
import { PiNotepadLight } from 'react-icons/pi'

const EmployeeAttendanceCard = ({ data, onDelete, clicked }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [attendanceData, setAttendanceData] = useState([])
  const [selectedAttendanceId, setSelectedAttendanceId] = useState(null)
  const [attendanceState, setAttendanceState] = useState({})

  const handleModalClick = (e) => {
    e.stopPropagation()
  }

  const getStatusDetails = (state) => {
    switch (state) {
      case 'entry':
        return {
          color: 'bg-muted_green text-white',
          icon: <AiOutlineCheckCircle className='text-white mr-2' />,
          text: 'Entry',
        }
      case 'exit':
        return {
          color: 'bg-error text-white',
          icon: <HiOutlineXCircle className='text-white mr-2' />,
          text: 'Exit',
        }
      case 'absent':
        return {
          color: 'bg-gold text-white',
          icon: <LuClock className='text-white mr-2' />,
          text: 'absent',
        }
      case 'cl':
        return {
          color: 'bg-gold text-white',
          icon: <LuClock className='text-white mr-2' />,
          text: 'absent',
        }
      case 'ml':
        return {
          color: 'bg-gold text-white',
          icon: <LuClock className='text-white mr-2' />,
          text: 'absent',
        }
      case 'holiday':
        return {
          color: 'bg-gold text-white',
          icon: <LuClock className='text-white mr-2' />,
          text: 'holiday',
        }
      default:
        return {
          color: 'bg-light_gray text-white',
          icon: null,
          text: 'No Status',
        }
    }
  }
  const getStatus = (data) => {
    switch (data?.status) {
      case 'ml':
        return {
          color: 'bg-gold text-white',
          icon: <LuClock className='text-white mr-2' />,
          text: 'Medical Leave',
        }
      case 'cl':
        return {
          color: 'bg-gold text-white',
          icon: <LuClock className='text-white mr-2' />,
          text: 'Casual Leave',
        }
      case 'absent':
        return {
          color: 'bg-error text-white',
          icon: <HiOutlineXCircle className='text-white mr-2' />,
          text: 'Absent',
        }
      case 'present':
        return {
          color: 'bg-muted_green text-white',
          icon: <AiOutlineCheckCircle className='text-white mr-2' />,
          text: 'Present',
        }
      case 'holiday':
        return {
          color: 'bg-muted_green text-white',
          icon: <AiOutlineCheckCircle className='text-white mr-2' />,
          text: 'holiday',
        }
      default:
        return {
          color: 'bg-error text-white',
          icon: null,
          text: 'No Status',
        }
    }
  }
  console.log(data)
  useEffect(() => {
    if (data?.attendances?.length > 0) {
      setAttendanceData(data.attendances)

      // Using forEach to update attendanceState
      const newState = {}
      data.attendances.forEach((attendance) => {
        newState[attendance.id] = attendance
      })
      setAttendanceState(newState)
    }
  }, [data])

  const handleDeleteClick = (e, attendanceId) => {
    e.stopPropagation() // This prevents the parent's onClick from firing
    setSelectedAttendanceId(attendanceId)
    setIsOpen(true)
  }

  return (
    <div
      onClick={() => clicked()}
      className='bg-tan/40 shadow-lg hover:cursor-pointer rounded-xl p-4 md:p-6 border border-tan w-full hover:shadow-xl transition-shadow duration-300'
    >
      {/* Status Badge */}
      <div className='flex justify-end mb-4'>
        <div
          className={`flex items-center ${
            getStatus(data).color
          } px-3 py-1.5 rounded-full shadow-sm`}
        >
          {getStatus(data).icon}
          <span className='text-sm font-medium ml-2'>
            {getStatus(data).text}
          </span>
        </div>
      </div>

      {/* Profile Section */}

      <div className='flex flex-col items-center mb-6'>
        {/* Profile Image - Always at the top */}
        <div className='flex justify-center mb-4'>
          <div className='relative'>
            <img
              src={
                data.profileImage ||
                'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
              }
              alt={`${data.name}'s profile`}
              className='w-24 h-24 rounded-full object-cover border-4 border-brown shadow-md'
            />
          </div>
        </div>

        {/* Profile Information - Below the image on all screen sizes */}
        <div className='flex-1 space-y-2 text-center'>
          <h2 className='text-xl md:text-2xl font-bold text-brown'>
            {data.name || 'John Doe'}
          </h2>
          <div className='flex items-center justify-center text-gray-600'>
            <BiBuildings className='mr-2' />
            <span className='text-sm'>{data.post || 'Manager'}</span>
          </div>
          <div className='flex items-center justify-center text-gray-600'>
            <HiOutlineIdentification className='mr-2' />
            <span className='text-sm'>ID: {data.employee_id}</span>
          </div>
        </div>
      </div>

      {/* Time Cards */}
      <div className='mb-6'>
        {attendanceData.map((el, i) => {
          const time = new Date(el.at).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })

          const statusDetails = getStatusDetails(el.state)
          return (
            <div
              key={i}
              className='border-2 border-tan mt-4 rounded-md  bg-cream'
            >
              <div className='flex justify-between pl-1 bg-tan/40 rounded-sm'>
                <p className='flex items-center uppercase gap-1'>
                  <span>
                    <LuClock className='text-tan' />
                  </span>
                  {time}
                </p>

                <div className='flex '>
                  <div
                    className={`flex items-center ${statusDetails.color} px-2 py-2  shadow-sm`}
                  >
                    {statusDetails.icon}
                    <span className='text-base  font-medium'>
                      {statusDetails.text}
                    </span>
                  </div>
                  <button
                    className='px-2 flex items-center gap-2 py-2 w-full bg-tan text-white hover:bg-tan/70'
                    onClick={(e) => handleDeleteClick(e, el.id)}
                  >
                    <FaRegTrashCan className='size-4' />
                  </button>
                </div>
              </div>
              {el.remark && (
                <p className='flex items-center capitalize'>
                  <span>
                    <PiNotepadLight className='text-tan' />
                  </span>
                  {el.remark}
                </p>
              )}
            </div>
          )
        })}
      </div>

      {/* Delete Modal */}
      {isOpen && (
        <div
          className='fixed inset-0 z-40 flex items-center justify-center bg-black/50 backdrop-blur-sm'
          onClick={handleModalClick}
        >
          <div
            className='bg-white p-6 rounded-xl shadow-xl w-11/12 max-w-md border border-gray-100 m-4'
            onClick={handleModalClick}
          >
            <h2 className='text-xl font-bold text-black mb-4'>
              Confirm Deletion
            </h2>
            <p className='text-gray-600 mb-6'>
              Are you sure you want to delete today's attendance record?
            </p>
            <div className='flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-end'>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  setIsOpen(false)
                }}
                className='px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors w-full sm:w-auto'
              >
                Cancel
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  onDelete(selectedAttendanceId)
                  setIsOpen(false)
                }}
                className='px-4 py-2 bg-rust text-white rounded-lg hover:bg-terracotta transition-colors w-full sm:w-auto'
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EmployeeAttendanceCard
